// extracted by mini-css-extract-plugin
export default {"weeks__nav":"WeekChooser_weeks__nav__hk1ML"};